import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './MarkdownText.module.css';

const inlineComponents = {
  p: ({ children }) => <>{children}</>,
  h1: ({ children }) => <>{children}</>,
  h2: ({ children }) => <>{children}</>,
  h3: ({ children }) => <>{children}</>,
  h4: ({ children }) => <>{children}</>,
  h5: ({ children }) => <>{children}</>,
  h6: ({ children }) => <>{children}</>,
  ul: ({ children }) => <>{children}</>,
  ol: ({ children }) => <>{children}</>,
  li: ({ children }) => <><span>{children}</span>{' '}</>,
  blockquote: ({ children }) => <>{children}</>,
  pre: ({ children }) => <>{children}</>,
  hr: () => <span>{' '}</span>,
};

const linklessComponents = {
  a: ({ children }) => <span className={styles.linkLike}>{children}</span>,
};

export default function MarkdownText({ value, inline = false, disableLinks = false, className = '' }) {
  if (!value) return null;

  const Wrapper = inline ? 'span' : 'div';
  const components = {
    ...(inline ? inlineComponents : {}),
    ...(disableLinks ? linklessComponents : {}),
  };

  return (
    <Wrapper className={`${styles.markdown} ${inline ? styles.inline : styles.block} ${className}`.trim()}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={Object.keys(components).length ? components : undefined}
      >
        {value}
      </ReactMarkdown>
    </Wrapper>
  );
}
